import React from "react";
import Drawer from "react-modern-drawer";

import { CheckoutConfigurationType } from "@is/constants";
import CheckoutDrawerContent from "@is/features/CheckoutDrawer/CheckoutDrawerContent";

import css from "./CheckoutDrawer.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onEditQuantity: () => void;
  checkoutConfigurationsType: CheckoutConfigurationType;
};

const CheckoutDrawer = ({
  isOpen,
  onClose,
  onEditQuantity,
  checkoutConfigurationsType,
}: Props) => {
  return (
    <Drawer
      open={isOpen}
      size="100vh"
      onClose={onClose}
      direction="bottom"
      enableOverlay={false}
      className={css.drawer}
      style={{ boxShadow: "none", border: "none" }}
    >
      {isOpen && (
        <CheckoutDrawerContent
          isOpen={isOpen}
          onClose={onClose}
          onEditQuantity={onEditQuantity}
          checkoutConfigurationsType={checkoutConfigurationsType}
        />
      )}
    </Drawer>
  );
};

export default CheckoutDrawer;
